import React from 'react'
import MessageBanner from 'LuxKit/Banners/MessageBanner'
import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import TextLink from 'LuxKit/TextLink'

type AccommodationRoomTileKnownMessage =
  'loading' |
  'members-exclusive' |
  'sold-out-on-dates' |
  'sold-out' |
  'exceeded-capacity' |
  'sold-out-on-dates-or-exceeded-capacity' |
  'available-on-dates' |
  'available-on-dates-variant' |
  'available-for-some-rooms'

interface Props {
  message: AccommodationRoomTileKnownMessage
  offer: App.HotelOffer | App.BedbankOffer
  onMultiRoomModeClick?: () => void
  onChangeOccupancyClick?: () => void
  onChangeDatesClick?: () => void
}

function AccommodationRoomTileMessage(props: Props) {
  const {
    message,
    offer,
    onMultiRoomModeClick,
    onChangeOccupancyClick,
    onChangeDatesClick,
  } = props

  const messageLabel = (() => {
    switch (message) {
      case 'members-exclusive':
        return 'Sign up to access exclusive rates'
      case 'sold-out-on-dates':
        return onChangeDatesClick ?
            <>This {offer.saleUnitLong} is sold out on your dates. Choose another {offer.saleUnit} or <TextLink onClick={onChangeDatesClick}>try different dates</TextLink>.</> :
          `This ${offer.saleUnitLong} is sold out on your dates`
      case 'sold-out':
        return `This ${offer.saleUnitLong} is sold out`
      case 'exceeded-capacity':
        return onChangeOccupancyClick ?
            <>This {offer.saleUnit} cannot accommodate your number of guests. Choose another {offer.saleUnit} or <TextLink onClick={onChangeOccupancyClick}>add more {offer.saleUnit}s</TextLink>.</> :
          `This ${offer.saleUnit} cannot accommodate your number of guests`
      case 'sold-out-on-dates-or-exceeded-capacity':
        return <>
          This {offer.saleUnit} is sold out on your dates or cannot accommodate your number of guests.
          {(onChangeDatesClick || onChangeOccupancyClick) && <> Choose another {offer.saleUnit}{onChangeDatesClick && <>, <TextLink onClick={onChangeDatesClick}>try different dates</TextLink></>}{onChangeOccupancyClick && <> or <TextLink onClick={onChangeOccupancyClick}>add more {offer.saleUnit}s</TextLink></>}.</>}
        </>
      case 'available-for-some-rooms':
        return onMultiRoomModeClick ?
            <>This {offer.saleUnit} type works for some {offer.saleUnit}s in your group, but not all. To select it, try <TextLink onClick={onMultiRoomModeClick}>choosing {offer.saleUnit}s individually</TextLink>.</> :
            <>This {offer.saleUnit} type works for some {offer.saleUnit}s in your group, but not all. To select it, try choosing {offer.saleUnit}s individually.</>
    }
  })()

  if (!messageLabel) return null

  return <MessageBanner kind="informational-primary" density="compact">
    {messageLabel}
  </MessageBanner>
}

export default withOfferPageAndReduxState((offerPageState) => ({
  offer: (offerPageState.offer ?? offerPageState.bedbankOffer)!,
}), AccommodationRoomTileMessage)
